<template>
  <trade-history-list></trade-history-list>
</template>
<script>
import tradeHistoryList from "@/views/customer/traderReport/tradeHistoryList";
export default {
  name: 'index',
  components: {
    tradeHistoryList
  }
}
</script>
